"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var taxIdKeyByCountry = {
  BR: 'br_cpf'
};

var getTaxIdKeyByCountry = function getTaxIdKeyByCountry(_ref) {
  var country = _ref.country;
  return taxIdKeyByCountry[country];
};

var _default = getTaxIdKeyByCountry;
exports["default"] = _default;
//# sourceMappingURL=getTaxIdKeyByCountry.js.map